/**
 * Decodes and normalizes customer account numbers from base64 encoded string
 * @param customerAccountsId - Base64 encoded customer account numbers (comma-separated)
 * @returns Array of normalized customer account numbers
 * @throws Error if the base64 string is invalid
 */
export const decodeCustomerAccountNumbers = (customerAccountsId: string): string[] => {
  return atob(customerAccountsId)
    .split(",")
    .map((splitString) => splitString.trim())
    .filter(Boolean);
};
